import { render, staticRenderFns } from "./PageDetails_Actions.vue?vue&type=template&id=005d99e4"
import script from "./PageDetails_Actions.vue?vue&type=script&lang=js"
export * from "./PageDetails_Actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports